// extracted by mini-css-extract-plugin
export default {"searchForm":"SearchBar_searchForm__tjhVX","searchInput":"SearchBar_searchInput__3ibzG","buttonContainer":"SearchBar_buttonContainer__x0H39","btn":"SearchBar_btn__jAG1A"};